import React from 'react';
import { Link } from 'react-router-dom';

const InvoiceQR = () => {
    return (
        <div className='flex flex-col space-y-8'>

            <div>
                <h1 className='text-5xl font-light mb-2'>Generating QR Code</h1>
                <p className='text-md text-gray-600'>Upload a base64 of an XML and get its scanable QR Code</p>
            </div>


            <div className="w-full">

                <div className="mb-4">
                    <h3 className="text-xl font-semibold mb-2">Endpoint</h3>
                    <p className='text-sm text-gray-600 mb-2'>Upload a Base64 of an XML then it will return the hash of the processed invoice.</p>
                    <pre className="bg-neutral-800 p-4 rounded text-gray-200 whitespace-pre-wrap">
                        <code className="text-blue-400">
                            <span className="text-green-400">https://</span>
                            <span className="text-yellow-400">zatca.</span>
                            <span className="text-yellow-300">bzsconnect</span>
                            <span className="text-yellow-400">.com</span>
                            <span className="text-green-400">/api</span>
                            <span className="text-blue-400">/invoice-qr</span>
                        </code>
                    </pre>
                </div>

                <div className="mb-4">
                    <h3 className="text-xl font-semibold mb-1">Options</h3>
                    <p className='text-sm text-gray-600 mb-2'>You can find Authorization Credentials from here: <Link to="/dashboard/authorization" className='pl-2 text-blue-500 underline'>Click here</Link></p>
                    <pre className="bg-neutral-800 p-4 rounded text-gray-200 whitespace-pre-wrap">
                        <code>
                            <span className="text-green-400">const</span> <span className="text-blue-400">options</span> = {'{'}
                            <br />
                            {'\u00A0\u00A0\u00A0\u00A0'}<span className="text-yellow-400">method</span>: <span className="text-red-400">'POST'</span>,
                            <br />
                            {'\u00A0\u00A0\u00A0\u00A0'}<span className="text-yellow-400">headers</span>: {'{'}
                            <br />
                            {'\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}<span className="text-yellow-400">'Content-Type'</span>: <span className="text-red-400">'application/json'</span>,
                            <br />
                            {'\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}<span className="text-yellow-400">'Authorization'</span>: <span className="text-red-400">'Basic '</span> + <span className="text-blue-400"></span>(<span className="text-red-400">'username:password'</span>),
                            <br />
                            {'\u00A0\u00A0\u00A0\u00A0'}{'}'}
                            <br />
                            {'}'}
                        </code>
                    </pre>

                </div>

                <div className="mb-4">
                    <h3 className="text-xl font-semibold mb-2">Parameters <span className="text-red-500 font-normal text-sm">required</span></h3>
                    <p className='text-sm text-gray-600 mb-2'>Upload a Base64 of an XML then it will return the hash of the processed invoice.</p>
                    <pre className="bg-neutral-800 p-4 rounded text-gray-200 whitespace-pre-wrap">
                        <code>
                            <span className="text-blue-400">{'{ '}</span>
                            <span className="text-green-400">XMLBase64</span>
                            <span className="text-blue-400">{' },'}</span>
                        </code>
                    </pre>
                </div>
                <div className="mb-4">
                    <h3 className="text-xl font-semibold mb-2">Response</h3>
                </div>
                <div className="space-y-4 rounded">
                    <pre className="flex flex-col space-y-2 bg-neutral-800 p-4 rounded text-gray-200">
                        <code className='text-sm'>[INFO] InvoiceQRService - Singed invoice QR generated succesfully</code>
                        <code className='text-sm'>[INFO] InvoiceQRService -  *** INVOICE QR Code = <span className='text-emerald-400'>AHEUAlXT31FtdAplSD41hiu7DjkA/tdkZn5jIgJMQPM=</span></code>
                    </pre>
                </div>
            </div>
        </div>
    );
};

export default InvoiceQR;